import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { normalize, schema } from 'normalizr';

import {
  GET_ASSET_HISTORICS,
  ACCEPT_ASSET_HISTORIC,
  REJECT_ASSET_HISTORIC,
  SET_ASSET_HISTORICS_PAGINATION,
  SET_ASSET_HISTORICS_FILTERS,
  RESET_ASSET_HISTORICS_LIST,
} from 'containers/assets/constants';

const historic = new schema.Entity('historics');

export const initialState = {
  filters: {
    fulltext: '',
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  needFetch: false,
  isLoading: false,
  isSaving: false,
  entities: { historics: {} },
  result: { historics: [] },
};

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const getPending = (state) => ({ ...state, isLoading: true });
export const getRejected = (state) => ({ ...state, isLoading: false });
export const getFulfilled = (state, { payload }) => {
  //TODO: no tiene limit???
  const pagination = {
    ...state.pagination,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ historics: payload.records }, { historics: [historic] });

  return {
    ...state,
    isLoading: false,
    pagination,
    ...normalized,
  };
};

export const acceptPending = (state) => ({ ...state, isSaving: true });
export const acceptRejected = (state) => ({ ...state, isSaving: false });
export const acceptFulfilled = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    historics: {
      ...state.entities.historics,
      [meta.historicId]: {
        ...state.entities.historics[meta.historicId],
        status: 'ACCEPTED',
      },
    },
  },
  isSaving: false,
});

export const rejectPending = (state) => ({ ...state, isSaving: true });
export const rejectRejected = (state) => ({ ...state, isSaving: false });
export const rejectFulfilled = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    historics: {
      ...state.entities.historics,
      [meta.historicId]: {
        ...state.entities.historics[meta.historicId],
        status: 'REJECTED',
      },
    },
  },
  isSaving: false,
});

export const reset = (state) => ({ ...initialState });

const reducers = {
  [GET_ASSET_HISTORICS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [ACCEPT_ASSET_HISTORIC]: {
    [PENDING]: acceptPending,
    [FULFILLED]: acceptFulfilled,
    [REJECTED]: acceptRejected,
  },

  [REJECT_ASSET_HISTORIC]: {
    [PENDING]: rejectPending,
    [FULFILLED]: rejectFulfilled,
    [REJECTED]: rejectRejected,
  },
  [SET_ASSET_HISTORICS_PAGINATION]: setPagination,
  [SET_ASSET_HISTORICS_FILTERS]: setFilters,
  [RESET_ASSET_HISTORICS_LIST]: reset,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/containers/assets/reducers_historics.js